import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { quizAPI } from '../services/api';
import { cookieUtils } from '../utils/cookies';

const HomePage = () => {
  const [name, setName] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect based on saved state
    const studentData = cookieUtils.getStudentData();
    const progress = cookieUtils.getProgress();
    if (studentData && studentData.status === 'completed') {
      navigate('/results');
      return;
    }
    if (studentData && progress && progress.inProgress) {
      navigate('/quiz');
      return;
    }
  }, [navigate]);

  const handleStartQuiz = async (e) => {
    e.preventDefault();
    if (!name.trim()) {
      setError('Please enter your name');
      return;
    }

    try {
      const response = await quizAPI.createStudent(name.trim());
      const studentData = response.data;
      
      // Store student data in cookies
      cookieUtils.setStudentData(studentData);
      
      // Navigate to quiz
      navigate('/quiz');
    } catch (error) {
      setError('Failed to start quiz. Please try again.');
    }
  };

  const handleInstructorAccess = () => {
    navigate('/login');
  };

  return (
    <div className="container">
      <div className="card">
        <h1 style={{ textAlign: 'center', marginBottom: '30px', color: '#333' }}>
          Supply Chain Statistics Quiz
        </h1>
        
        <div style={{ textAlign: 'center', marginBottom: '40px' }}>
          <p style={{ fontSize: '18px', color: '#666', marginBottom: '20px' }}>
            Welcome to the Supply Chain Statistics Quiz!
          </p>
          <p style={{ color: '#888' }}>
            This quiz contains 30 questions (15 theory + 15 case studies) with a 30-minute time limit.
          </p>
        </div>

        <form onSubmit={handleStartQuiz}>
          <div className="form-group">
            <label className="form-label" htmlFor="name">
              Enter your name to start the quiz:
            </label>
            <input
              id="name"
              type="text"
              className="form-input"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Your full name"
              required
            />
          </div>

          {error && <div className="error-message">{error}</div>}

          <div style={{ textAlign: 'center', marginTop: '30px' }}>
            <button type="submit" className="btn">
              Start Quiz
            </button>
          </div>
        </form>

        <div style={{ textAlign: 'center', marginTop: '40px', paddingTop: '20px', borderTop: '1px solid #eee' }}>
          <p style={{ color: '#666', marginBottom: '15px' }}>
            Instructor Access
          </p>
          <button 
            type="button" 
            className="btn btn-secondary"
            onClick={handleInstructorAccess}
          >
            Instructor Login
          </button>
        </div>
      </div>
    </div>
  );
};

export default HomePage;
